import logo from "../../images/themelogo.png"


export default function MeLogo() {
  return (
    <img className="m-logo" src={logo} alt="me logo" />
   
  );
}